module.exports = __webpack_public_path__ + "img/dall_log1.e64e14e1.png";